import React, { useState } from "react";
import { Control, UseFormReset } from "react-hook-form";
import {
  ClientDiscountForm,
  ClientInfoForm,
} from "features/ClientInfo/ClientInfo";
import { useGetClientAccount } from "features/ClientInfo/api";
import { useClientsState } from "atoms/clientsAtom";

import { AccordionParent } from "components/AccordionParent/AccordionParent";
import { Accordion } from "components/Accordion/Accordion";

import {
  Bonuses,
  BonusOperations,
  Discounts,
  Marketing,
  AdditionalInfo,
} from "./components";

type Props = {
  control: Control<ClientInfoForm>;
  isEdit?: boolean;
  clientDiscountReset: UseFormReset<ClientDiscountForm>;
  clientDiscountControl: Control<ClientDiscountForm>;
};

export const PersonalAccount = ({
  control,
  isEdit,
  clientDiscountReset,
  clientDiscountControl,
}: Props): JSX.Element => {
  const [discountsCollapse, setDiscountsCollapse] = useState(false);
  const [bonusesCollapseCollapse, setBonusesCollapseCollapse] = useState(false);
  const [bonusOperationsCollapse, setBonusOperationsCollapse] = useState(false);
  const [marketingCollapse, setMarketingCollapse] = useState(false);
  const [additionalInfo, setAdditionalInfo] = useState(false);

  const { clientsState } = useClientsState();

  useGetClientAccount(
    clientsState.activeItem?.clientid || "",
    (res) => {
      clientDiscountReset({ ...res, shiftpercentsum: res?.shiftpercentsum });
    },
    Boolean(isEdit && clientsState.activeItem)
  );

  return (
    <div>
      <Accordion
        disabled={!isEdit}
        className="mt-5"
        withIcon={false}
        handleCollapse={() => setDiscountsCollapse((prevState) => !prevState)}
        collapsed={!discountsCollapse}
        iconClassNames="mr-3.5"
        parent={
          <AccordionParent
            disabled={!isEdit}
            name="Скидки"
            collapsed={!discountsCollapse}
            iconClassNames="mr-3.5"
          />
        }
      >
        <Discounts clientDiscountControl={clientDiscountControl} />
      </Accordion>
      <Accordion
        disabled={!isEdit}
        className="mt-5"
        withIcon={false}
        handleCollapse={() =>
          setBonusesCollapseCollapse((prevState) => !prevState)
        }
        collapsed={!bonusesCollapseCollapse}
        iconClassNames="mr-3.5"
        parent={
          <AccordionParent
            disabled={!isEdit}
            name="Бонусы"
            collapsed={!bonusesCollapseCollapse}
            iconClassNames="mr-3.5"
          />
        }
      >
        <Bonuses clientDiscountControl={clientDiscountControl} />
      </Accordion>
      {isEdit && (
        <>
          <Accordion
            className="mt-5"
            withIcon={false}
            handleCollapse={() =>
              setBonusOperationsCollapse((prevState) => !prevState)
            }
            collapsed={!bonusOperationsCollapse}
            iconClassNames="mr-3.5"
            parent={
              <AccordionParent
                name="Операции по бонусам"
                collapsed={!bonusOperationsCollapse}
                iconClassNames="mr-3.5"
              />
            }
          >
            <BonusOperations />
          </Accordion>
        </>
      )}
      <Accordion
        className="mt-5"
        withIcon={false}
        handleCollapse={() => setMarketingCollapse((prevState) => !prevState)}
        collapsed={!marketingCollapse}
        iconClassNames="mr-3.5"
        parent={
          <AccordionParent
            name="Маркетинг"
            collapsed={!marketingCollapse}
            iconClassNames="mr-3.5"
          />
        }
      >
        <Marketing control={control} isEdit={isEdit} />
      </Accordion>
      <Accordion
        className="mt-5"
        withIcon={false}
        handleCollapse={() => setAdditionalInfo((prevState) => !prevState)}
        collapsed={!additionalInfo}
        iconClassNames="mr-3.5"
        parent={
          <AccordionParent
            name="Дополнительная информация"
            collapsed={!additionalInfo}
            iconClassNames="mr-3.5"
          />
        }
      >
        <AdditionalInfo control={control} />
      </Accordion>
    </div>
  );
};
